import type { Color } from "three"

export default function createSingleColorRGBFloat32Array(
  color: Color,
  count: number,
): Float32Array {
  const array = new Float32Array(count * 3)
  for (let i = 0; i < count; i++) {
    array[i * 3] = color.r
    array[i * 3 + 1] = color.g
    array[i * 3 + 2] = color.b
  }
  return array
}